// The ess/tgs/tes pages read the zone the user is looking at out of the URL
// hash (`#location=<zone>&specificLocation=<zone>`): IntegratedSwitchLocations
// derives `isExpanded` from it and scrolls that zone into view. Routing to the
// page without it lands the user at the top of the location list.
//
// Passing an empty value clears that key, so a stale sub-location from an
// earlier selection does not survive into the next one.
const updateSelectionHash = (newParams) => {
  const currentHash = window.location.hash.replace('#', '');
  const params = new URLSearchParams(currentHash);

  Object.keys(newParams).forEach((key) => {
    if (newParams[key]) {
      params.set(key, newParams[key]);
    } else {
      params.delete(key);
    }
  });

  // pushState rather than assigning location.hash: assigning jumps the page to
  // the fragment, which fights the scroll-into-view the page runs next
  window.history.pushState({}, '', `#${params.toString()}`);
};

export default updateSelectionHash;
